'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PlayerStore = require('../stores/PlayerStore'),
    StampStore = require('../stores/StampStore'),
    LightboxStore = require('../stores/LightboxStore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    SoundCloudPlayer = require('../atoms/SoundCloudPlayer'),
    AudioPlayer = require('../atoms/AudioPlayer'),
    getStreamUrl = require('../utils/getStreamUrl'),
    PlayerActionCreators = require('../actions/PlayerActionCreators'),
    TimeoutTransitionGroup = require('../utils/TimeoutTransitionGroup'),
    DefaultAudioImage = require('../constants/DefaultAudioImage'),
    StickyPlayer = require('../organisms/StickyPlayer');

var StickyPlayerHost = React.createClass({
  mixins: [createStoreMixin(PlayerStore, StampStore, LightboxStore), PureRenderMixin, ClassNameMixin],

  getInitialState() {
    return {
      hasErrored: false
    };
  },

  getStateFromStores() {
    var mediaId = PlayerStore.getStickyMediaId(),
        sourceStampId = PlayerStore.getSourceStampId(mediaId);

    return {
      activeMediaId: mediaId,
      isPlaying: PlayerStore.isPlaying(mediaId),
      isPaused: PlayerStore.isPaused(mediaId),
      activeTrack: PlayerStore.getActiveTrack(mediaId),
      activeTrackIndex: PlayerStore.getActiveTrackIndex(mediaId),
      currentTime: PlayerStore.getCurrentTime(mediaId),
      sourceStamp: sourceStampId ? StampStore.get(sourceStampId) : null,
      isInLightbox: LightboxStore.isActive(),
      artwork: PlayerStore.getArtwork(mediaId) || DefaultAudioImage,
      background: PlayerStore.getBackground(mediaId) || DefaultAudioImage
    };
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeTrack !== this.state.activeTrack) {
      this.setState({
        hasErrored: false
      });
    }
  },

  render() {
    return (
      <div>
        {this.renderPlayer()}
        <TimeoutTransitionGroup className={this.getClassName()}
                                transitionName='StickyPlayer'
                                enterTimeout={500 + 500}
                                leaveTimeout={500}>
          {this.renderStickyPlayer()}
        </TimeoutTransitionGroup>
      </div>
    );
  },

  renderPlayer() {
    var { hasErrored, activeTrack, isPlaying, activeMediaId, activeTrackIndex } = this.state,
        streamUrl = activeTrack && getStreamUrl(activeTrack),
        soundCloudUrl = activeTrack && activeTrack.url,
        useNativePlayer = !hasErrored && streamUrl,
        Player = useNativePlayer ? AudioPlayer : SoundCloudPlayer,
        source = useNativePlayer ? streamUrl : soundCloudUrl;

    if (!activeTrack) {
      return null;
    }

    return (
      <Player key={'player-' + activeMediaId + '-' + activeTrackIndex}
              source={source}
              isPlaying={isPlaying}
              currentTime={this.state.currentTime}
              onTimeUpdate={this.handlePlayerTimeUpdate}
              onEnd={this.handlePlayerEnd}
              onError={this.handlePlayerError} />
    );
  },

  renderStickyPlayer() {
    var { activeTrack, isPlaying, isPaused, sourceStamp, isInLightbox, activeMediaId, artwork, background } = this.state;
    if (!activeTrack || isInLightbox) {
      return null;
    }

    return (
      <StickyPlayer key={'StickyPlayer-' + activeMediaId}
                    uuid={activeMediaId}
                    track={activeTrack}
                    artwork={artwork}
                    colors={background.colors}
                    sourceStamp={sourceStamp}
                    currentTime={this.state.currentTime}
                    isPlaying={isPlaying}
                    isPaused={isPaused}
                    onPlay={this.handlePlayPauseClick}
                    onPause={this.handlePlayPauseClick}
                    onBackward={this.handlePreviousClick}
                    onForward={this.handleNextClick} />
    );
  },

  handlePlayerTimeUpdate(time) {
    var { activeMediaId } = this.state;
    PlayerActionCreators.setCurrentTime(activeMediaId, time.currentTime);
  },

  handlePlayerError() {
    this.setState({
      hasErrored: true
    });
  },

  handlePlayPauseClick() {
    var { activeMediaId, isPlaying } = this.state;

    if (isPlaying) {
      PlayerActionCreators.pause(activeMediaId);
    } else {
      PlayerActionCreators.play(activeMediaId);
    }
  },

  handlePreviousClick() {
    var { activeMediaId } = this.state;
    PlayerActionCreators.playPrevious(activeMediaId);
  },

  handleNextClick() {
    var { activeMediaId } = this.state;
    PlayerActionCreators.playNext(activeMediaId);
  },

  handlePlayerEnd() {
    var { activeMediaId } = this.state;
    PlayerActionCreators.playNext(activeMediaId);
  }
});

module.exports = StickyPlayerHost;



/** WEBPACK FOOTER **
 ** ./hosts/StickyPlayerHost.jsx
 **/